module.exports = __webpack_public_path__ + "static/media/slider-gif2.826a01e1.gif";